/**
 * MINMAXIFY VARIANT INTEGRATION
 * Purpose: Syncs quantity limits when product variants change.
 * * Why the delays? 
 * This theme uses multiple apps (Easify, Per Mask) that modify the product form.
 * We trigger the sync multiple times to ensure we catch the final state after 
 * all apps have finished their updates.
 */

(function() {
    // We keep one single log so you can verify the file is loading in the console
    console.log('Minmaxify Integration: Active');

    function syncMinmaxify() {
        const qtyInput = document.querySelector('input[name="quantity"]');
        const variantInput = document.querySelector('input[name="id"]');
        
        // If the quantity field or the Minmaxify app isn't ready, stop here
        if (!qtyInput || !window.minMaxify) return;

        // 1. Force the hidden variant ID to broadcast a change
        // This ensures Minmaxify knows exactly which variant is now active
        if (variantInput) {
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 2. Send the refresh signal to the Minmaxify app
        document.dispatchEvent(new CustomEvent('minmaxify:refresh'));

        // 3. Trigger events on the quantity box to force validation checks
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));

        // 4. Call the app's internal logic helper if available
        if (typeof window.minMaxify.onChange === 'function') {
            window.minMaxify.onChange();
        }
    }

    // Listen for the theme's variant update event
    document.addEventListener('variant:update', function() {
        // Trigger 1: Immediate (for fast themes)
        syncMinmaxify(); 

        // Trigger 2: 500ms (to allow other apps like Easify to finish)
        setTimeout(syncMinmaxify, 500);

        // Trigger 3: 1000ms (Insurance policy for slow network/loading)
        setTimeout(syncMinmaxify, 1000);
    });
})();